import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient) { }

    // Handle API errors
    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
          'Something bad happened; please try again later.');
    }

    errorHanlder(error: HttpErrorResponse){
        return throwError(error.message || 'Server Error');
    }

    // GET
    getAPI(link, variables, pHeaders) {

        const httpParams = new HttpParams();
        for (const field in variables) {
          if (variables.hasOwnProperty(field)) {
            httpParams.set(field, variables[field]);
          }
        }
        httpParams.set('responseType', 'text');
        const options = {params: httpParams, headers: new HttpHeaders()};
        for (const field in pHeaders) {
          if (pHeaders.hasOwnProperty(field)) {
            options.headers = options.headers.set(field, pHeaders[field]);
            // console.log('%c set headers , key = ' + field + ', value = ' + pHeaders[field], 'color:blue');
          }
        }
        // options.headers = options.headers.set('responseType', 'text');
        // return this.http.get(link, options).pipe(retry(1), catchError(this.handleError))
        return this.http.get(link, options).pipe(retry(1), catchError(this.errorHanlder));
    }
    getHttpClient() {
      return this.http;
    }
}
